export enum ValidationErrors {
    ROOM_NOT_AVAILABLE = 'The selected room is not available',
    BASE_PRICE_MISMATCH = 'Mismatch between submitted and recorded price',
    INVALID_USER_DETAILS = 'Submitted user details are invalid',
    NO_BUILDING_FOR_ROOM = 'No building found for this room',
    EXPECTED_NULL = 'Expected null',
    EXPECTED_ONLY_NIF = 'Only the NIF is required',
    EXPECTED_ONLY_NIE = 'Only the NIE is required',
    EXPECTED_ONLY_PASSPORT = 'Only the passport number is required',
    EXPECTED_PASSPORT_NUMBER = 'Expected a passport number',
    EXPECTED_PASSPORT_ISSUING_COUNTRY = 'Expected a passport issuing country',
    EXPECTED_NIE_NUMBER = 'Expected an NIE number',
    EXPECTED_NIF_NUMBER = 'Expected an NIF number',
    INVALID_NIE_NUMBER = 'Invalid NIE number',
    INVALID_NIF_NUMBER = 'Invalid NIF number',
}
